import React from 'react';

import * as styles from './OfficeCard.module.scss';

export default function OfficeCard({ name, address }) {
  return (
    <article className={styles.card}>
      <span className={styles.name}>{name}</span>
      <h3 className={styles.location}>{address}</h3>
    </article>
  );
}
